import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Row } from 'reactstrap';
import Notifications from './Notifications';
import { PageHeader, Section } from '../../shared/components';

const NotificationsPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Container className="notifications">
      <PageHeader title={t('notifications')} noBack />
      <Row>
        <Section>
          <Notifications />
        </Section>
      </Row>
    </Container>
  );
};

export default NotificationsPage;
